import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import Badge from '@/components/component-library/Badge';
import { classes } from '@/helpers/styling';
import CaretIcon from '@/components/component-library/Icon/types/Caret';

const GenreOptionComponent = React.forwardRef(({
  id,
  value,
  selected,
  className,
  isMoreElement
}, ref) => (
  <Badge
    className={ classes(
      className,
      styles.genreBadge,
      {
        [styles.isSelected]: selected,
        [styles.isMoreOption]: id === 'more',
        [styles.isMoreElement]: isMoreElement
      }
    ) }
    disableTextWrap
    isClickable
    ref={ ref }
    title={ (
      <>
        { value }
        { !!isMoreElement && <CaretIcon /> }
      </>
    ) }
  />
));

GenreOptionComponent.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  className: PropTypes.string,
  isMoreElement: PropTypes.bool
};

GenreOptionComponent.defaultProps = {
  selected: false,
  className: '',
  isMoreElement: false
};

export const GenreOptionComponentMobile = React.forwardRef(({ className, ...props }, ref) => (
  <GenreOptionComponent
    className={ classes(className, styles.isMobile) }
    ref={ ref }
    { ...props }
  />
));

GenreOptionComponentMobile.propTypes = { className: PropTypes.string };

GenreOptionComponentMobile.defaultProps = { className: '' };

export default GenreOptionComponent;